import { Link } from 'react-router-dom';
import moment from 'jalali-moment';
import React from 'react';
import Style from '../reserve/__reserve.module.css';

/*
    - ihoDesignSystem
*/
import { Badge, Box, Button, Dropdown, Grid, Image, Modal, Select, TextField, Tooltip, Typography } from '@iho-design-system/Loader';

/*
    - icon
*/
import ChevronDownSVG from '../../assets/images/icons/chevron-down.svg';
import EmptySVG from '../../assets/images/icons/empty.svg';
import InfoBlueSVG from '../../assets/images/icons/info-blue.svg';
import InfoDarkSVG from '../../assets/images/icons/info-dark.svg';
import LoadingCustomSVG from '../../assets/images/icons/loading-custom.svg';
import ObserverSVG from '../../assets/images/icons/observer.svg';
import VerticalDotsSVG from '../../assets/images/icons/vertical-dots.svg';

/*
    - api
*/
import post from '../../api/post';
import InvoicePdf from '../../api/get/InvoicePdf';
import VoucherPdf from '../../api/get/VoucherPdf';
import OfficialInvoice from '../../api/get/OfficialInvoice';

const Reserve = ({ props, alertProps, reloadDashboardProps }) => {

    const [activeReserves, setActiveReserves] = React.useState('loading');
    const [activeTab, setActiveTab] = React.useState(['bg-gray-light', 'bg-white']);
    const [selectedReserve, setSelectedReserve] = React.useState('');
    const [tabType, setTabType] = React.useState('naturalPerson');
    const [userCompaniesHistory, setUserCompaniesHistory] = React.useState('empty');
    const [officialInvoiceParameters, setOfficialInvoiceParameters] = React.useState({
        name: { value: '', color: 'dark' },
        ecoNum: { value: '', color: 'dark' },       
        codeMelli: { value: '', color: 'dark' },
        regNum: { value: '', color: 'dark' },
        tel: { value: '', color: 'dark' },
        mobile: { value: '', color: 'dark' },
        postalCode: { value: '', color: 'dark' },
        companyAddress: { value: '', color: 'dark' },
        postAddress: { value: '', color: 'dark' }
    });

    React.useEffect(() => {
        if (props.activeReserves !== '') {
            if (props.activeReserves.status === 200 && props.activeReserves.data.length > 0) {
                setActiveReserves(props.activeReserves.data);
            } else {
                setActiveReserves('empty');
            }
        }
        if (props.userCompaniesHistory.status === 200 && props.userCompaniesHistory.data.length > 0) {
            setUserCompaniesHistory(props.userCompaniesHistory.data);
        } else {
            setUserCompaniesHistory([]);
        }
    }, [props]);

    const officialInvoiceHandler = (key, value) => {
        const setColor = (isValid) => isValid ? 'dark' : 'danger';
        const updates = {};

        if (key === 'name') updates.name = { value, color: setColor(value !== '' && /^[آ-ی ]+$/.test(value)) };
        if (key === 'ecoNum') updates.ecoNum = { value, color: setColor(value !== '') };
        if (key === 'codeMelli') updates.codeMelli = { value, color: setColor(value !== '') };
        if (key === 'regNum') updates.regNum = { value, color: 'dark' };
        if (key === 'tel') updates.tel = { value, color: setColor(value !== '' && /^[\u06F0-\u06F90-9]+$/.test(value)) };
        if (key === 'mobile') updates.mobile = { value, color: setColor(value.length === 11 && /^[\u06F0-\u06F90-9]+$/.test(value)) };
        if (key === 'postalCode') updates.postalCode = { value, color: setColor(value.length === 10 && /^[\u06F0-\u06F90-9]+$/.test(value)) };
        if (key === 'companyAddress') updates.companyAddress = { value, color: setColor(value !== '') };
        if (key === 'postAddress') updates.postAddress = { value, color: setColor(value !== '') };

        setOfficialInvoiceParameters(prev => ({ ...prev, ...updates }));
    };

    const officialInvoice = async () => {
        let isValid = true;
        const setDanger = (field) => {
            setOfficialInvoiceParameters(prev => ({ ...prev, [field]: { ...prev[field], color: 'danger' } }));
            isValid = false;
        };

        if (officialInvoiceParameters.name.value === '' || !/^[آ-ی ]+$/.test(officialInvoiceParameters.name.value)) setDanger('name');
        if (officialInvoiceParameters.codeMelli.value === '') setDanger('codeMelli');
        if (officialInvoiceParameters.tel.value === '' || !/^[\u06F0-\u06F90-9]+$/.test(officialInvoiceParameters.tel.value)) setDanger('tel');
        if (officialInvoiceParameters.mobile.value.length !== 11 || !/^[\u06F0-\u06F90-9]+$/.test(officialInvoiceParameters.mobile.value)) setDanger('mobile');
        if (officialInvoiceParameters.postalCode.value.length !== 10 || !/^[\u06F0-\u06F90-9]+$/.test(officialInvoiceParameters.postalCode.value)) setDanger('postalCode');
        if (officialInvoiceParameters.companyAddress.value === '') setDanger('companyAddress');
        if (officialInvoiceParameters.postAddress.value === '') setDanger('postAddress');

        if (tabType === 'legalPerson') {
            if (officialInvoiceParameters.ecoNum.value === '') setDanger('ecoNum');
            if (officialInvoiceParameters.regNum.value === '') setDanger('regNum');
        }

        if (isValid) {
            const body = {
                reserveId: selectedReserve.nuRequest,
                Name: officialInvoiceParameters.name.value,
                EcoNum: officialInvoiceParameters.ecoNum.value,
                CodeMelli: officialInvoiceParameters.codeMelli.value,
                RegNum: officialInvoiceParameters.regNum.value,
                Tel: officialInvoiceParameters.tel.value,
                Mobile: officialInvoiceParameters.mobile.value,
                PostalCode: officialInvoiceParameters.postalCode.value,
                CompanyAddress: officialInvoiceParameters.companyAddress.value,
                PostAddress: officialInvoiceParameters.postAddress.value
            };

            const parameters = {
                ctrl: 'Booking',
                method: 'Officialinvoice',
                query: selectedReserve.nuRequest,
                body
            };

            const result = await post(parameters);
            if (result.status === 200) {
                alertProps(['success', 'عملیات با موفقیت انجام شد']);
                reloadDashboardProps(`${Math.floor(Math.random() * 100)},reserve`);
            } else {
                alertProps(['danger', result.data.Message]);
            }
            closeModal('officalInvoice');
            setOfficialInvoiceParameters({
                name: { value: '', color: 'dark' },
                ecoNum: { value: '', color: 'dark' },
                codeMelli: { value: '', color: 'dark' },
                regNum: { value: '', color: 'dark' },
                tel: { value: '', color: 'dark' },
                mobile: { value: '', color: 'dark' },
                postalCode: { value: '', color: 'dark' },
                companyAddress: { value: '', color: 'dark' },
                postAddress: { value: '', color: 'dark' }
            });
        }
    };

    const officalInvoice = async (nuRequest) => {
        const params = { reserveId: nuRequest };
        OfficialInvoice(params);
    };

    const downloadLink = async (type, nuRequest) => {
        const params = { reserveId: nuRequest };
        if (type === 'invoice') InvoicePdf(params);
        if (type === 'voucher') VoucherPdf(params);
    };

    const reserveSource = (nuRequest) => {
        window.open(`/persian/pursuit/reserveRespond/${nuRequest}`, '_blank');
    };

    const autoFillOfficialInvoice = (selectedName) => {
        const company = userCompaniesHistory.find(obj => obj.Name === selectedName);
        if (company) {
            setOfficialInvoiceParameters({
                name: { value: company.Name, color: 'dark' },
                ecoNum: { value: company.EcoNum, color: 'dark' },
                codeMelli: { value: company.Codemelli, color: 'dark' },
                regNum: { value: company.RegNum, color: 'dark' },
                tel: { value: company.Tel, color: 'dark' },
                mobile: { value: company.Mobile, color: 'dark' },
                postalCode: { value: company.PostalCode, color: 'dark' },
                companyAddress: { value: company.CompanyAddress, color: 'dark' },
                postAddress: { value: company.PostAddress, color: 'dark' }
            });
        }
    };

    const extraInfoToggle = (event) => {
        const parent = event.target.closest('.parent-class');
        const slideUp = parent.querySelector('.slide-up');
        const slideDown = parent.querySelector('.slide-down');
        if (slideUp) {
            slideUp.classList.add('slide-down');
            slideUp.classList.remove('slide-up');
        }
        if (slideDown) {
            slideDown.classList.add('slide-up');
            slideDown.classList.remove('slide-down');
        }
    };

    const openModal = (modal, reserve) => {
        setSelectedReserve(reserve);
        document.querySelector(`.${modal}`).classList.remove('d-none');
    };

    const closeModal = (modal) => {
        document.querySelector(`.${modal}`).classList.add('d-none');
    };

    const toggleTab = (isLegal) => {
        setOfficialInvoiceParameters({
            name: { value: '', color: 'dark' },
            ecoNum: { value: '', color: 'dark' },
            codeMelli: { value: '', color: 'dark' },
            regNum: { value: '', color: 'dark' },
            tel: { value: '', color: 'dark' },
            mobile: { value: '', color: 'dark' },
            postalCode: { value: '', color: 'dark' },
            companyAddress: { value: '', color: 'dark' },
            postAddress: { value: '', color: 'dark' }
        });
        setActiveTab(isLegal ? ['bg-white', 'bg-gray-light'] : ['bg-gray-light', 'bg-white']);
        setTabType(isLegal ? 'legalPerson' : 'naturalPerson');
    };

    const screenWidth = window.innerWidth;
    let scale = '';
    if (screenWidth > 1400) scale = 'xx-large';
    else if (screenWidth <= 1400 && screenWidth > 1200) scale = 'x-large';
    else if (screenWidth <= 1200 && screenWidth > 992) scale = 'large';
    else if (screenWidth <= 992 && screenWidth > 768) scale = 'medium';
    else if (screenWidth <= 768 && screenWidth > 576) scale = 'small';
    else if (screenWidth <= 576) scale = 'x-small';

    if (activeReserves === 'loading') {
        return (
            <Image className="d-block mx-auto" src={LoadingCustomSVG} ms={{ width: '40px', height: '40px' }} />
        );
    }

    if (activeReserves === 'empty') {
        return (
            <Box className="my-xxl mb-0">
                <Image className="mx-auto" src={EmptySVG} ms={{ display: 'block', width: '120px', height: '120px' }} />
                <Typography className="d-block text-center" component="h2">
                لیست رزروهای فعال شما خالی است :(
                </Typography>
                <Box className="my-md" />
                <Typography className="d-block text-center" component="strong">
                تاکنون هیچ رزروی ثبت نکرده اید!
                </Typography>
            </Box>
        );
    }

    return (
        <React.Fragment>
            <Box className="d-flex justify-content-between align-item-center my-lg mt-0">
                <Typography component="h4" ms={{ fontWeight: 'normal !important' }}>
                    آخرین رزروها
                </Typography>
                <Box className="text-center">
                    <Link to={'/reserve'}>
                        <Typography className="px-lg bg-blue-medium rounded-sm text-white" ms={{ lineHeight: '40px' }}>
                            مشاهده تمامی رزروها
                        </Typography>
                    </Link>
                </Box>
            </Box>

            <Grid>
                {activeReserves.map((obj, index) => (
                    <Grid.Wrapper
                        key={index}
                        className="parent-class my-lg mt-0 px-xl bg-white border-solid border-light rounded-lg shadow-dark-hover pointer"
                    >
                        <Grid.Item size="col-11 lg-3 sm-4">
                            <Box onClick={extraInfoToggle} className="d-flex align-item-center">
                                <Box className="mx-lg mr-0">
                                    <Tooltip ms={{ verticalAlign: 'middle' }}>
                                        <Box className="rounded-circle" ms={{ width: '12px', height: '12px', backgroundColor: 'var(--green-medium)' }} />
                                        <Tooltip.Text position="top">
                                            رزرو فعال
                                        </Tooltip.Text>
                                    </Tooltip>
                                </Box>
                                <Box>
                                    <Typography className="d-block" component="strong">
                                        {obj.hotelName.length <= 20 ? obj.hotelName : obj.hotelName.substr(0, 20) + '...'}
                                    </Typography>
                                    <Typography ms={{ color: '#6F6F7E' }}>
                                        کد پیگیری :
                                    </Typography>
                                    <Typography ms={{ color: '#6F6F7E' }}>
                                        {obj.nuRequest}
                                    </Typography>
                                    {scale === 'x-small' && (
                                        <>
                                            <Box className="w-100">
                                                <Typography component="small">مبلغ : </Typography>
                                                <Typography className="text-primary" component="strong">
                                                    {(obj.priceToPeyFinal / 10).toLocaleString()} تومان
                                                </Typography>
                                            </Box>
                                            <Box className="w-100">
                                                <Typography>
                                                    <Badge color="primary">
                                                        <Tooltip>
                                                            {obj.stateText.length <= 20 ? obj.stateText : obj.stateText.substr(0, 20) + '...'}
                                                            <Tooltip.Text position="top">{obj.stateText}</Tooltip.Text>
                                                        </Tooltip>
                                                    </Badge>
                                                </Typography>
                                            </Box>
                                        </>
                                    )}
                                </Box>
                            </Box>
                        </Grid.Item>

                        {(scale === 'xx-large' || scale === 'x-large' || scale === 'large') && (
                            <>
                                <Grid.Item className="d-flex" ms={{ gap: 'var(--sizing-xxl)' }} size="col-6">
                                    <Box>
                                        <Typography className="d-block" component="small">رزرو کننده</Typography>
                                        <Typography>
                                            {obj.userFullName.length <= 15 ? obj.userFullName : obj.userFullName.substr(0, 10) + '...'}
                                            {obj.agentFullName !== null && (
                                                <Tooltip>
                                                    <Image className="d-inline mx-xs ml-0" src={InfoDarkSVG} ms={{ width: '16px', height: '16px' }} />
                                                    <Tooltip.Text position="top">
                                                        {obj.userFullName} ({obj.agentFullName})
                                                    </Tooltip.Text>
                                                </Tooltip>
                                            )}
                                        </Typography>
                                    </Box>
                                    <Box>
                                        <Typography className="d-block" component="small">ثبت رزرو</Typography>
                                        <Typography>{moment.from(obj.insertDate.split('T')[0]).locale('fa').format('YYYY-MM-DD').replaceAll('-', '/')}</Typography>
                                    </Box>
                                    <Box>
                                        <Typography className="d-block" component="small">ورود به هتل</Typography>
                                        <Typography>{moment.from(obj.arrivalDate.split('T')[0]).locale('fa').format('YYYY-MM-DD')}</Typography>
                                    </Box>
                                    <Box>
                                        <Typography className="d-block" component="small">وضعیت</Typography>
                                        <Typography>
                                            <Badge color="primary">
                                                <Tooltip>
                                                    {obj.stateText.length <= 20 ? obj.stateText : obj.stateText.substr(0, 20) + '...'}
                                                    <Tooltip.Text position="top">{obj.stateText}</Tooltip.Text>
                                                </Tooltip>
                                            </Badge>
                                        </Typography>
                                    </Box>
                                </Grid.Item>
                                <Grid.Item size="col-3 lg-2">
                                        <Typography className="d-block" component="small">مبلغ</Typography>
                                    <Typography className="text-primary" component="strong">
                                        {(obj.priceToPeyFinal / 10).toLocaleString()} تومان
                                    </Typography>
                                </Grid.Item>
                                <Grid.Item className={`d-flex align-item-center justify-content-end ${Style.reserveDivider} position-relative`} size="col-1">
                                    <Image onClick={() => reserveSource(obj.nuRequest)} src={ObserverSVG} ms={{ width: '16px', height: '16px' }} />
                                    <Box className="mx-sm" />
                                    <Dropdown ms={{ whiteSpace: 'nowrap' }}>
                                        <Dropdown.Toggle>
                                            <Image src={VerticalDotsSVG} ms={{ width: '16px', height: '16px' }} />
                                        </Dropdown.Toggle>
                                        <Dropdown.Body position="center" ms={{ top: '180% !important' }}>
                                            {obj.officialInvoiceStatusId === 0 && obj.statusId === 101 && (
                                                <>
                                                    <Typography onClick={() => openModal('officalInvoice', obj)} component="small">
                                                        درخواست فاکتور رسمی
                                                    </Typography>
                                                    <Box className="my-sm" />
                                                </>
                                            )}
                                            {obj.officialInvoiceStatusId === 1 && (
                                                <>
                                                    <Typography onClick={() => openModal('officalInvoice', obj)} component="small">
                                                    درخواست فاکتور رسمی (در حال بررسی)
                                                    </Typography>
                                                    <Box className="my-sm" />
                                                </>
                                            )}
                                            {obj.officialInvoiceStatusId === 2 && (
                                                <>
                                                    <Typography onClick={() => officalInvoice(obj.nuRequest)} component="small">
                                                    دانلود فاکتور رسمی
                                                    </Typography>
                                                    <Box className="my-sm" />
                                                </>
                                            )}
                                            <Typography onClick={() => downloadLink('invoice', obj.nuRequest)} component="small">
                                                دریافت رسید
                                            </Typography>
                                            {obj.statusId === 101 && (
                                                <>
                                                    <Box className="my-sm" />
                                                    <Typography onClick={() => downloadLink('voucher', obj.nuRequest)} component="small">
                                                        دریافت واچر
                                                    </Typography>
                                                </>
                                            )}
                                        </Dropdown.Body>
                                    </Dropdown>
                                </Grid.Item>
                            </>
                        )}

                        {(scale === 'medium' || scale === 'small' || scale === 'x-small') && (
                            <>
                                <Grid.Item className="d-flex justify-content-end align-item-center" size="col-1">
                                    <Image onClick={extraInfoToggle} src={ChevronDownSVG} ms={{ width: '16px', height: '16px' }} />
                                </Grid.Item>
                                <Grid.Item className="p-0 slide-up" size="col-12">
                                    <Grid>
                                        <Grid.Wrapper>
                                            <Grid.Item size="col-6 sm-2">
                                                <Typography component="small" className="d-block">ثبت رزرو</Typography>
                                                <Typography>{moment.from(obj.insertDate.split('T')[0]).locale('fa').format('YYYY-MM-DD').replaceAll('-', '/')}</Typography>
                                            </Grid.Item>
                                            <Grid.Item size="col-5 sm-9">
                                                <Typography component="small" className="d-block">ورود به هتل</Typography>
                                                <Typography>{moment.from(obj.arrivalDate.split('T')[0]).locale('fa').format('YYYY-MM-DD')}</Typography>
                                            </Grid.Item>
                                            <Grid.Item className="d-flex align-item-center justify-content-center" size="col-1">
                                                <Image onClick={() => reserveSource(obj.nuRequest)} src={ObserverSVG} ms={{ width: '16px', height: '16px' }} />
                                                <Box className="mx-sm" />
                                                <Dropdown ms={{ whiteSpace: 'nowrap' }}>
                                                    <Dropdown.Toggle>
                                                        <Image src={VerticalDotsSVG} ms={{ width: '16px', height: '16px' }} />
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Body position="bottomLeft" ms={{ top: '180% !important' }}>
                                                        {obj.officialInvoiceStatusId === 0 && obj.statusId === 101 && (
                                                            <>
                                                                <Typography onClick={() => openModal('officalInvoice', obj)} component="small">
                                                                    درخواست فاکتور رسمی
                                                                </Typography>
                                                                <Box className="my-sm" />
                                                            </>
                                                        )}
                                                        {obj.officialInvoiceStatusId === 1 && (
                                                            <>
                                                                <Typography onClick={() => openModal('officalInvoice', obj)} component="small">
                                                                    درخواست فاکتور رسمی (در حال بررسی)
                                                                </Typography>
                                                                <Box className="my-sm" />
                                                            </>
                                                        )}
                                                        {obj.officialInvoiceStatusId === 2 && (
                                                            <>
                                                                <Typography onClick={() => officalInvoice(obj.nuRequest)} component="small">
                                                                    دانلود فاکتور رسمی
                                                                </Typography>
                                                                <Box className="my-sm" />
                                                            </>
                                                        )}
                                                        <Typography onClick={() => downloadLink('invoice', obj.nuRequest)} component="small">
                                                            دریافت رسید
                                                        </Typography>
                                                        {obj.statusId === 101 && (
                                                            <>
                                                                <Box className="my-sm" />
                                                                <Typography onClick={() => downloadLink('voucher', obj.nuRequest)} component="small">
                                                                    دریافت واچر
                                                                </Typography>
                                                            </>
                                                        )}
                                                    </Dropdown.Body>
                                                </Dropdown>
                                            </Grid.Item>
                                        </Grid.Wrapper>
                                    </Grid>
                                </Grid.Item>
                            </>
                        )}
                    </Grid.Wrapper>
                ))}
            </Grid>

            <Modal className="officalInvoice">
                <Modal.Wrapper size="xs" ms={{ '@media(max-width:576px)': { width: 'calc(100% - 12px) !important' } }}>
                    <Modal.Header className="border-solid-bottom border-light">
                    فاکتور رسمی
                        <Box />
                    </Modal.Header>

                    {selectedReserve?.officialInvoiceStatusId === 0 && (
                        <>
                            <Box className="my-md mt-0" />
                            <Typography className="px-lg">
                            فاکتور رسمی پس از پایان اقامت شما صادر می شود.
                            </Typography>
                            <Box className="p-sm" component="form">
                                {tabType === 'legalPerson' && (
                                    <>
                                        <Select onChange={autoFillOfficialInvoice} label={'شرکت‌های ثبت شده'} placeholder={'انتخاب شرکت ثبت شده'}>
                                            {userCompaniesHistory.map((obj, index) => (
                                                <Select.Item key={index} value={obj.Name}>
                                                    {obj.Name} - {obj.EcoNum}
                                                </Select.Item>
                                            ))}
                                        </Select>
                                        <Box className="my-xl mt-0" />
                                    </>
                                )}
                                <Box className="d-flex justify-content-center">
                                    <Typography onClick={() => toggleTab(false)} className={`p-sm ${activeTab[0]} rounded-sm pointer`}>
                                        حقیقی
                                    </Typography>
                                    <Box className="d-inline-block mx-lg" />
                                    <Typography onClick={() => toggleTab(true)} className={`p-sm ${activeTab[1]} rounded-sm pointer`}>
                                        حقوقی
                                    </Typography>
                                </Box>
                                <Box className="my-md mb-0 divider-horizontal divider-light" />
                                <Grid>
                                    <Grid.Wrapper>
                                        {tabType === 'naturalPerson' && (
                                            <>
                                                <Grid.Item size="sm-6 col-12">
                                                    <TextField onChange={(v) => officialInvoiceHandler('name', v)} label={'نام و نام‌خانوادگی'} color={officialInvoiceParameters.name.color} value={officialInvoiceParameters.name.value} />
                                                </Grid.Item>
                                                <Grid.Item size="sm-6 col-12">
                                                    <TextField onChange={(v) => officialInvoiceHandler('codeMelli', v)} label={'شماره ملی'} color={officialInvoiceParameters.codeMelli.color} value={officialInvoiceParameters.codeMelli.value} />
                                                </Grid.Item>
                                                <Grid.Item size="sm-6">
                                                    <TextField onChange={(v) => officialInvoiceHandler('tel', v)} label={' تلفن'} color={officialInvoiceParameters.tel.color} value={officialInvoiceParameters.tel.value} />
                                                </Grid.Item>
                                                <Grid.Item size="sm-6">
                                                    <TextField onChange={(v) => officialInvoiceHandler('mobile', v)} label={' تلفن همراه'} color={officialInvoiceParameters.mobile.color} value={officialInvoiceParameters.mobile.value} />
                                                </Grid.Item>
                                                <Grid.Item size="col-4">
                                                    <TextField onChange={(v) => officialInvoiceHandler('postalCode', v)} label={'کد پستی'} color={officialInvoiceParameters.postalCode.color} value={officialInvoiceParameters.postalCode.value} />
                                                </Grid.Item>
                                                <Grid.Item size="col-8">
                                                    <TextField onChange={(v) => officialInvoiceHandler('postAddress', v)} label={'نشانی پستی'} color={officialInvoiceParameters.postAddress.color} value={officialInvoiceParameters.postAddress.value} />
                                                </Grid.Item>
                                                <Grid.Item className="d-flex pb-0" size="col-12 md-6">
                                                    <Button onClick={officialInvoice} className="w-75" variant="filled" color="primary">
                                                        صادرات فاکتور رسمی
                                                    </Button>
                                                    <Box className="d-inline-block mx-sm" />
                                                    <Button className="w-25" onClick={() => closeModal('officalInvoice')} variant="outlined" color="primary">
                                                        انصراف
                                                    </Button>
                                                </Grid.Item>
                                            </>
                                        )}
                                        {tabType === 'legalPerson' && (
                                            <>
                                                <Grid.Item size="sm-6 col-12">
                                                    <TextField onChange={(v) => officialInvoiceHandler('name', v)} label='نام و نام‌خانوادگی' color={officialInvoiceParameters.name.color} value={officialInvoiceParameters.name.value} />
                                                </Grid.Item>
                                                <Grid.Item size="sm-6 col-6">
                                                    <TextField onChange={(v) => officialInvoiceHandler('ecoNum', v)} label='شماره اقتصادی' color={officialInvoiceParameters.ecoNum.color} value={officialInvoiceParameters.ecoNum.value} />
                                                </Grid.Item>
                                                <Grid.Item size="sm-6 col-6">
                                                    <TextField onChange={(v) => officialInvoiceHandler('codeMelli', v)} label='شناسه ملی' color={officialInvoiceParameters.codeMelli.color} value={officialInvoiceParameters.codeMelli.value} />
                                                </Grid.Item>
                                                <Grid.Item size="sm-6 col-12">
                                                    <TextField onChange={(v) => officialInvoiceHandler('regNum', v)} label='شماره ثبت' color={officialInvoiceParameters.regNum.color} value={officialInvoiceParameters.regNum.value} />
                                                </Grid.Item>
                                                <Grid.Item size="sm-6 col-6">
                                                    <TextField onChange={(v) => officialInvoiceHandler('tel', v)} label=' تلفن' color={officialInvoiceParameters.tel.color} value={officialInvoiceParameters.tel.value} />
                                                </Grid.Item>
                                                <Grid.Item size="sm-6 col-6">
                                                    <TextField onChange={(v) => officialInvoiceHandler('mobile', v)} label=' تلفن همراه' color={officialInvoiceParameters.mobile.color} value={officialInvoiceParameters.mobile.value} />
                                                </Grid.Item>
                                                <Grid.Item size="sm-4 col-12">
                                                    <TextField onChange={(v) => officialInvoiceHandler('postalCode', v)} label='کد پستی' color={officialInvoiceParameters.postalCode.color} value={officialInvoiceParameters.postalCode.value} />
                                                </Grid.Item>
                                                <Grid.Item size="sm-8 col-12">
                                                    <TextField onChange={(v) => officialInvoiceHandler('companyAddress', v)} label='نشانی ' color={officialInvoiceParameters.companyAddress.color} value={officialInvoiceParameters.companyAddress.value} />
                                                </Grid.Item>
                                                <Grid.Item size="sm-12 col-12">
                                                    <TextField onChange={(v) => officialInvoiceHandler('postAddress', v)} label='نشانی پستی' color={officialInvoiceParameters.postAddress.color} value={officialInvoiceParameters.postAddress.value} />
                                                </Grid.Item>
                                                <Grid.Item className="d-flex pb-0" size="col-12 md-6">      
                                                    <Button onClick={officialInvoice} className="w-75" color="primary">
                                                        صادرات فاکتور رسمی
                                                    </Button>
                                                    <Box className="d-inline-block mx-sm" />
                                                    <Button className="w-25" onClick={() => closeModal('officalInvoice')} variant="outlined" color="primary">
                                                        انصراف
                                                    </Button>
                                                </Grid.Item>
                                            </>
                                        )}
                                    </Grid.Wrapper>
                                </Grid>
                            </Box>
                        </>
                    )}

                    {selectedReserve?.officialInvoiceStatusId === 1 && (
                        <Typography className="d-flex align-item-center p-lg pb-0">
                            <Image src={InfoBlueSVG} ms={{ display: 'inline-block', width: '30px', height: '30px', verticalAlign: 'middle' }} />
                            <Box className="mx-sm mr-0" component="span" />
                            درخواست شما برای صدور فاکتور رسمی، درحال بررسی می باشد.
                        </Typography>
                    )}
                </Modal.Wrapper>
            </Modal>
        </React.Fragment>
    );
};

export default Reserve;